import React from "react";
import { Link } from "react-router-dom";

const ProductImportStep = ({ step }) => {
  if (!step) return null;

  return (
    <aside className="mb-10 max-w-2xl card-board p-6">
      <p className="text-sm font-display font-bold tracking-widest uppercase text-brand-gold-ink">
        AI Assist
      </p>
      <h2 className="mt-2 font-display font-bold text-xl text-brand-charcoal tracking-tight">
        <Link to={step.to} className="underline text-brand-gold-ink">
          {step.label}
        </Link>
      </h2>
      <p className="mt-2 text-sm text-brand-muted leading-relaxed">
        {step.detail}
      </p>
    </aside>
  );
};

export default ProductImportStep;
